<template>
  <div class="d-flex">
    <router-link
      tag="div"
      class="nav-btn d-flex flex-column align-items-center justify-content-center mx-2"
      :class="{ selected: currentSelectedPage === 'home' }"
      to="/"
    >
      <img
        :src="
          currentSelectedPage === 'home' ? getHomeImgFilled() : getHomeImg()
        "
      />
      <span class="pt-2">Home</span>
    </router-link>

    <router-link
      tag="div"
      class="nav-btn d-flex flex-column align-items-center justify-content-center mx-2"
      :class="{ selected: currentSelectedPage === 'scenarios' }"
      to="/scenarios"
    >
      <img
        :src="
          currentSelectedPage === 'scenarios'
            ? getScenarioImgFilled()
            : getScenarioImg()
        "
      />
      <span class="pt-2">Scenarios</span>
    </router-link>

    <router-link
      v-if="user.canProvision && isOnNative"
      tag="div"
      class="nav-btn d-flex flex-column align-items-center justify-content-center mx-2"
      :class="{ selected: currentSelectedPage === 'provisioning' }"
      to="/me/provisioning"
    >
      <img
        :src="
          currentSelectedPage === 'provisioning'
            ? getLicensingImgFilled()
            : getLicensingImg()
        "
      />
      <span class="pt-2">Licensing</span>
    </router-link>

    <router-link
      tag="div"
      class="nav-btn d-flex flex-column align-items-center justify-content-center mx-2"
      :class="{ selected: currentSelectedPage === 'tms' }"
      to="/tms"
    >
      <img
        :src="currentSelectedPage === 'tms' ? getTmsImgFilled() : getTmsImg()"
      />
      <span class="pt-2">TMS</span>
    </router-link>

    <DeviceInformation
      v-if="user.canProvision && isOnNative"
    ></DeviceInformation>
    <NotificationDropdown v-if="user"></NotificationDropdown>
    <LoggedInUser
      v-if="user"
      :user="user.first_name + ' ' + user.last_name"
      :currentSelectedPage="currentSelectedPage"
    ></LoggedInUser>
  </div>
</template>

<script>
import NotificationDropdown from "./NotificationDropdown";
import LoggedInUser from "./LoggedInUser";
import DeviceInformation from "./DeviceInformation";

export default {
  name: "NavExpandedButtons",
  components: {
    NotificationDropdown,
    LoggedInUser,
    DeviceInformation,
  },
  computed: {
    user() {
      return this.$store.getters.getUser;
    },
    isOnNative() {
      return this.$store.getters.getIsOnNative;
    },
    currentSelectedPage() {
      if (this.$route.path === "/feed") return "home";
      if (this.$route.path === "/scenarios") return "scenarios";
      if (this.$route.path === "/me/provisioning") return "provisioning";
      if (this.$route.path.includes("tms")) return "tms";

      return "me";
    },
  },
  methods: {
    getHomeImg() {
      return require("../../assets/nav-icons/home.svg");
    },
    getHomeImgFilled() {
      return require("../../assets/nav-icons/home-fill.svg");
    },
    getLicensingImg() {
      return require("../../assets/nav-icons/provision-device.svg");
    },
    getLicensingImgFilled() {
      return require("../../assets/nav-icons/provision-device-fill.svg");
    },
    getScenarioImg() {
      return require("../../assets/nav-icons/health.svg");
    },
    getScenarioImgFilled() {
      return require("../../assets/nav-icons/health-fill.svg");
    },
    getTmsImg() {
      return require("../../assets/nav-icons/tms.svg");
    },
    getTmsImgFilled() {
      return require("../../assets/nav-icons/tms-fill.svg");
    },
  },
};
</script>

<style scoped></style>
